import { styled, SvgIcon } from '@mui/material';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';

export const IconStyled = styled(SvgIcon)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const EditIcon = styled(CreateOutlinedIcon)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  width: '1.5rem',
  height: '1.5rem',
  fill: theme.palette.common.white
}));
